import {
  GET_USER_FAVOURITES,
  DELETE_USER_FAVOURITE,
  SORT_FAVS_AZ,
  SORT_FAVS_ZA,
  SORT_FAVS_BY_DATE,
} from "../enums";
import { Dispatch } from "react";
import { httpClient } from "../../clients/auth/addTokenToHTTPRequests";

export const getUserFavourites = () => async (dispatch: Dispatch<any>) => {
  return await httpClient.instance
    .get("/user/favourites")
    .then((res) => {
      dispatch({
        type: GET_USER_FAVOURITES,
        favourites: res.data,
      });
    })
    .catch((e) => {
      // if error save favs as empty
      console.log(e);
      dispatch({
        type: GET_USER_FAVOURITES,
        favourites: [],
      });
    });
};

export const addToUserFavourite =
  (itemId: number, itemData?: ItemData) => async (dispatch: Dispatch<any>) => {
    // Create the request payload
    const payload: any = {
      item_id: itemId,
      item_name: itemData?.name,
      item_image_url: itemData?.image_url
    };

    // If itemData is provided and has pricing information, include vendors array
    if (itemData && itemData.item_pricing && itemData.item_pricing.length > 0) {
      // Create vendors array with pricing information for all vendors
      const vendors = itemData.item_pricing.map(pricing => {
        // Create base vendor object
        const vendorObj = {
          vendor_id: pricing.vendor_id,
          price: typeof pricing.price === 'number' ? pricing.price : 0,
          volume: pricing.volume || '',
          cup_price: typeof pricing.cup_price === 'number' ? pricing.cup_price : 0,
          cup_volume: pricing.cup_volume || '100g',
          special: pricing.special || false,
          vendor_product_code: pricing.vendor_product_code || itemId.toString()
        };
        
        // Include multibuy data when it exists and is valid
        if (typeof pricing.multibuy_price === 'number' && pricing.multibuy_price > 0 && 
            typeof pricing.multibuy_quantity === 'number' && pricing.multibuy_quantity > 0) {
          // @ts-ignore - Adding properties that might not be in type definition
          vendorObj.multibuy_price = pricing.multibuy_price;
          // @ts-ignore - Adding properties that might not be in type definition
          vendorObj.multibuy_quantity = pricing.multibuy_quantity;
        }
        
        return vendorObj;
      });

      // Add vendors array to the payload
      payload.vendors = vendors;
    }

    console.log('Adding to favorites with payload:', payload);

    return await httpClient.instance
      .post("/user/favourites/", payload)
      .then(async (res) => {
        // this doesnt update it
        dispatch(getUserFavourites());
      })
      .catch((e) => {
        console.log(e);
      });
  };

export const deleteUserFavourite =
  (itemId: number) => async (dispatch: Dispatch<any>) => {
    return await httpClient.instance
      .delete("/user/favourites/" + itemId)
      .then((res) => {
        dispatch({
          type: DELETE_USER_FAVOURITE,
          deletedId: itemId,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const sortUserFavourite = (type: string) => {
  return {
    type:
      type === "A-Z"
        ? SORT_FAVS_AZ
        : type === "Z-A"
        ? SORT_FAVS_ZA
        : SORT_FAVS_BY_DATE,
  };
};
